import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@upmc/ims.component-library';

import { Headline5 } from '../../components/UI/MDC/Typography/Typography';
import * as actions from '../../store/ancillary/actions';
import * as utils from '../../utils';
import classes from './UserAccessReview.module.scss';
import OrgChartIdentity from '../../components/OrgChart/OrgChartIdentity';
import * as lifecycleWrapper from './util/lifecycleWrapper';
import UARLayout from './containers/Layout';

const OrgChart = props => {
	/**
	 * Extract needed variables from the props provided by the `Scaffold`
	 */
	const { dispatch, error, setError, errorMessage, loading, setLoading } =
		props;

	//STATE
	const [org, setOrg] = useState({});

	//LIFECYCLE
	useEffect(() => {
		//GET data from API
		const queryParams = new URLSearchParams(props.location.search);
		lifecycleWrapper.queryGetOrgChartByEsoFiId(
			queryParams,
			onGetOrgChartInfoQuery,
			onGetOrgChartInfoResponse,
			onGetOrgChartInfoSuccess,
			onGetOrgChartInfoFailure,
			onGetOrgChartInfoError,
			onGetOrgChartInfoComplete
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.location.search]);

	const onGetOrgChartInfoResponse = data => {
		for (let member in data.staff) {
			data.staff[member].selected = false;
			data.staff[member].key = data.staff[member].esoFiId;
			data.staff[
				member
			].value = `${data.staff[member].lastName}, ${data.staff[member].firstName}`;
		}
		return data;
	};

	const onGetOrgChartInfoQuery = () => {
		//clear all messages
		dispatch(actions.clearMessages());
		//update "loading"
		setLoading(true);
	};

	const onGetOrgChartInfoComplete = () => {};

	const onGetOrgChartInfoSuccess = (data, messages) => {
		setLoading(false);
		dispatch(actions.clearMessages());
		setError(false);
		setOrg(data);
		messages.forEach(message => {
			dispatch(actions.addMessage(message));
		});
	};

	const onGetOrgChartInfoError = error => {
		setError(true);
		dispatch(
			actions.addMessage({
				Key: 3,
				Value: 'No data returned.',
			})
		);
	};

	const onGetOrgChartInfoFailure = messages => {
		dispatch(actions.clearMessages());
		if (messages) {
			messages.forEach(m => dispatch(actions.addMessage(m)));
		}
		setError(true);
		setLoading(false);
	};
	//RENDER
	return (
		<UARLayout
			title={'Organization Chart'}
			loading={loading}
			error={error}
			errorMessage={errorMessage}
			canPerformActions={true}
		>
			<section
				className={utils.concatenateClassNames(
					['org__container--vertical'],
					classes
				)}
			>
				<section
					className={utils.concatenateClassNames(
						['org__container'],
						classes
					)}
				>
					{org.supervisor ? (
						<section
							className={utils.concatenateClassNames(
								['org__item', 'org__item--supervisor'],
								classes
							)}
						>
							<Link
								to={{
									pathname: '/UserAccessReview/OrgChart',
									search: `?esoFiId=${org.supervisor.esoFiId}`,
								}}
								className={utils.concatenateClassNames(
									'org__link',
									classes
								)}
							>
								<OrgChartIdentity
									name={org.supervisor.name}
									title={org.supervisor.title}
									email={org.supervisor.email}
								/>
							</Link>
							<Link
								to={{
									pathname: `/UserAccessReview/AccountDetails`,
									search: `?esoFiId=${org.supervisor.esoFiId}`,
								}}
								className={utils.concatenateClassNames(
									'org__link',
									classes
								)}
							>
								<Button
									variant='text'
									fullWidth={true}
									sx={{color: 'white'}}
								> View More Info </Button>
							</Link>
						</section>
					) : (
						<Headline5>No supervisor</Headline5>
					)}
				</section>
				<section
					className={utils.concatenateClassNames(
						['org__container'],
						classes
					)}
				>
					{org.target ? (
						<section
							className={utils.concatenateClassNames(
								['org__item', 'org__item--you'],
								classes
							)}
						>
							<Link
								to={{
									pathname: `/UserAccessReview/OrgChart`,
									search: `?esoFiId=${org.target.esoFiId}`,
								}}
								className={utils.concatenateClassNames(
									'org__link',
									classes
								)}
							>
								<OrgChartIdentity
									name={org.target.name}
									title={org.target.title}
									email={org.target.email}
								/>
							</Link>
							<Link
								to={{
									pathname: `/UserAccessReview/AccountDetails`,
									search: `?esoFiId=${org.target.esoFiId}`,
								}}
								className={utils.concatenateClassNames(
									'org__link',
									classes
								)}
							>
								<Button
										variant='text'
										fullWidth={true}
										sx={{color: 'white'}}
								> View More Info </Button>
							</Link>
						</section>
					) : (
						<Headline5>No Information</Headline5>
					)}
				</section>
				<section
					className={utils.concatenateClassNames(
						['org__container'],
						classes
					)}
				>
					{org.reports && org.reports.length > 0 ? (
						org.reports.map(report => (
							<section
								className={utils.concatenateClassNames(
									['org__item', 'org__item--reports'],
									classes
								)}
							>
								<Link
									to={{
										pathname: `/UserAccessReview/OrgChart`,
										search: `?esoFiId=${report.esoFiId}`,
									}}
									className={utils.concatenateClassNames(
										'org__link',
										classes
									)}
								>
									<OrgChartIdentity
										name={report.name}
										title={report.title}
										email={report.email}
									/>
								</Link>
								<Link
									to={{
										pathname: `/UserAccessReview/AccountDetails`,
										search: `?esoFiId=${report.esoFiId}`,
									}}
									className={utils.concatenateClassNames(
										'org__link',
										classes
									)}
								>
									<Button
										variant='text'
										fullWidth={true}
										sx={{color: 'white'}}
									> View More Info </Button>
								</Link>
							</section>
						))
					) : (
						<Headline5>No Staff.</Headline5>
					)}
				</section>
			</section>
		</UARLayout>
	);
};

export default OrgChart;
